// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesOperator
 */
export interface TypesOperator {
  /**
   *
   * @type {string}
   * @memberof TypesOperator
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof TypesOperator
   */
  status?: string;
}

/**
 * Check if a given object implements the TypesOperator interface.
 */
export function instanceOfTypesOperator(value: object): value is TypesOperator {
  return true;
}

export function TypesOperatorFromJSON(json: any): TypesOperator {
  return TypesOperatorFromJSONTyped(json, false);
}

export function TypesOperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesOperator {
  if (json == null) {
    return json;
  }
  return {
    name: json['Name'] == null ? undefined : json['Name'],
    status: json['Status'] == null ? undefined : json['Status'],
  };
}

export function TypesOperatorToJSON(json: any): TypesOperator {
  return TypesOperatorToJSONTyped(json, false);
}

export function TypesOperatorToJSONTyped(
  value?: TypesOperator | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Name: value['name'],
    Status: value['status'],
  };
}
